<template>
  <div>
    <Table border :columns="fields" :data="list">
      <template slot-scope="{ column, index }" slot="content">
        <Input v-model="list[index][column.key]"></Input>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="add(index)"
          >{{ $tz("添加") }}</Button
        >
        <Button
          :disabled="list.length <= 1"
          type="error"
          size="small"
          @click="del(index)"
          >{{ $tz("删除") }}</Button
        >
      </template>
    </Table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    read: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list(newValue, oldValue) {
      if (!this.read && !newValue.length) {
        this.add();
      }
    },
  },
  mounted() {
    if (!this.read) {
      if (this.list.length <= 0) this.add();
    }
  },
  data() {
    return {
      fields: [
        {
          title: this.$tz("英文商品名称"),
          key: "invoiceName",
          slot: "content",
        },
        {
          title: this.$tz("商品数量,(pcs)"),
          key: "invoicePCS",
          slot: "content",
        },
        {
          title: this.$tz("商品毛重,(KG)"),
          key: "invoiceWeight",
          slot: "content",
        },
        {
          title: this.$tz("申报价值,(USD)"),
          key: "invoiceInsValue",
          slot: "content",
        },
        {
          title: this.$tz("商品Sku码"),
          key: "invoiceDescription",
          slot: "content",
        },
        {
          title: this.$tz("海关编码"),
          key: "invoiceHSCod",
          slot: "content",
        },
        {
          title: this.$tz("操作"),
          key: "action",
          slot: "action",
          width: 180,
        },
      ],
    };
  },
  methods: {
    add(index) {
      let obj = {};
      this.fields.forEach((t) => {
        obj[t.key] = "";
      });
      this.list.splice(index + 1, 0, obj);
    },
    del(index) {
      this.list.splice(index, 1);
    },
  },
};
</script>

<style scoped>
</style>